import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import TagService from "../../services/TagService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormTag extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idTag: "",
            nome: ""
        };

        this.state.crud = {
            service: TagService,
            labels: {
                title: 'Tag',
            },
            urlList: '/LstTag',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idTag} name="idTag" readOnly opcionalLabel={false}/>
                <InputText label="Nome da Tag" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormTag {...props} navigate={navigate} params={params} />
}

export default With